module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/east_asia_and_pacific-95c9084b69502af9504293307289f327.svg";